import { buildCompositionTableRows, type CompositionTableRow } from './compositionProjectionAdapter';
import type { ClosingPackageProjection } from '../types';

export type SendScansDocumentRow = CompositionTableRow & {
  hasScan: boolean;
  readyToSend: boolean;
};

export function isSendScansDocumentReady(row: CompositionTableRow): boolean {
  const linkedDocumentId = row.item.compositionMeta?.linkedDocumentId;
  return linkedDocumentId != null && row.state !== 'MISSING';
}

export function buildSendScansDocumentRows(
  projection: ClosingPackageProjection
): SendScansDocumentRow[] {
  return buildCompositionTableRows(projection).map((row) => {
    const hasScan = row.fileName != null && row.state !== 'MISSING';
    return {
      ...row,
      hasScan,
      readyToSend: isSendScansDocumentReady(row),
    };
  });
}
